import { Box, FormControlLabel, FormHelperText, Switch } from '@mui/material';

interface InspectionAutoRunFieldProps {
  value: boolean;
  setValue: (value: boolean) => void;
  setChanged: () => void;
  edit?: boolean;
}

export default function InspectionAutoRunField({
  value,
  setValue,
  setChanged,
  edit = false,
}: InspectionAutoRunFieldProps): React.JSX.Element {
  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={value}
            disabled={edit}
            onChange={(_, checked) => {
              setValue(checked);
              setChanged();
            }}
            color='primary'
          />
        }
        label='Auto Run'
      />
      <FormHelperText>
        Automatically run inspection after document preparation finishes.
      </FormHelperText>
    </Box>
  );
}
